import React from "react";
import { FaPhone, FaEnvelope, FaInstagram } from "react-icons/fa";
import { Container, Row, Col } from "reactstrap";

function Footer() {
  return (
    <footer
      className="footer"
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f8f9fa",
        padding: "2rem 0",
      }}
    >
      <Container>
        <Row className="text-center mt-5">
        <Col md="6" sm="12" className="mb-3">
            <FaPhone size={20} color="#007bff" />{" "}
            <a
              href="tel:05402770001"
              style={{ fontSize: "1rem", color: "#343a40", textDecoration: "none" }}
            >
              0(540){" "}
              <span
                style={{
                  display: "inline-flex",
                  flexDirection: "column",
                  alignItems: "center",
                  verticalAlign: "middle",
                  marginRight: "4px",
                }}
              >
                <span
                  style={{
                    fontSize: "0.7rem",
                    fontWeight: "bold",
                    color: "#d9534f",
                    lineHeight: "1",
                  }}
                >
                  ARS
                </span>
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "1rem",
                    color: "#d9534f",
                    lineHeight: "1",
                  }}
                >
                  277
                </span>
              </span>{" "}
              00 01
            </a>
          </Col>

          <Col md="6" sm="12" className="mb-3">
            <FaEnvelope size={20} color="#007bff" />{" "}
            <a
              href="mailto:iletisim@arshukukburosu.com"
              style={{ fontSize: "1rem", color: "#343a40", textDecoration: "none" }}
            >
              iletisim@arshukukburosu.com
            </a>
          </Col>

        </Row>

        {/* Sosyal Medya */}
        <Row className="text-center">
          <Col md="12" className="mb-3">
            <a
              href="https://www.instagram.com/ars.hukukburosu"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "1rem",
                color: "#343a40",
                textDecoration: "none",
              }}
            >
              <FaInstagram size={22} color="#E1306C" />
              @ars.hukukburosu
            </a>
          </Col>
        </Row>

        {/* Google Map */}
        <Row className="mt-4">
          <Col md="12" className="text-center">
            <iframe
              title="ARS Hukuk Konum"
              width="100%"
              height="300"
              frameBorder="0"
              style={{ border: 0, borderRadius: "10px" }}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3011.605262568015!2d29.102967676241747!3d40.99012372054227!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cac707a38356bb%3A0x2cf02059a19c357d!2sARS%20HUKUK!5e0!3m2!1str!2str!4v1763314098323!5m2!1str!2str"
              allowFullScreen
            ></iframe>
          </Col>

          
        </Row>
        <Row>
          <Col md="12" className="text-center mt-4">
            <hr />
            <p style={{ fontSize: "0.9rem", color: "#6c757d" }}>
              © {new Date().getFullYear()}, Tüm hakları saklıdır.{" "}
              <a href="/" style={{ textDecoration: "none", color: "#007bff" }}>
                ARS Hukuk
              </a>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;